export default ".quotes a {\n  position: relative;\n}\n.quotes .notifications {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  z-index: 100;\n}";